<template>
  <NcrmRecordEditDialog
    :model-value="modelValue"
    :title="title"
    :loading="loading"
    :save-disabled="saveDisabled"
    :save-label="saveLabel"
    :max-width="maxWidth"
    @update:model-value="emitModelValue"
    @save="$emit('save')"
  >
    <div class="d-grid ga-3">
      <v-text-field
        :model-value="dealName"
        :label="$t('ncrm.leads.details.dialogs.convert.dealName')"
        maxlength="190"
        @update:model-value="$emit('update:dealName', $event)"
      />
      <v-select
        :model-value="dealPipelineId"
        :items="pipelineOptions"
        item-title="label"
        item-value="id"
        :menu-props="selectMenuProps"
        :label="$t('ncrm.leads.details.dialogs.convert.pipeline')"
        @update:model-value="handlePipelineChange"
      />
      <v-select
        :model-value="dealStageId"
        :items="dealStageOptions"
        item-title="label"
        item-value="id"
        :menu-props="selectMenuProps"
        :label="$t('ncrm.leads.details.dialogs.convert.dealStage')"
        @update:model-value="$emit('update:dealStageId', $event)"
      />
      <v-select
        :model-value="leadStageId"
        :items="leadStageOptions"
        item-title="label"
        item-value="id"
        :menu-props="selectMenuProps"
        :label="$t('ncrm.leads.details.dialogs.convert.leadStage')"
        clearable
        @update:model-value="$emit('update:leadStageId', $event)"
      />
      <v-select
        :model-value="ownerUserId"
        :items="ownerOptions"
        item-title="label"
        item-value="id"
        :menu-props="selectMenuProps"
        :label="$t('ncrm.leads.details.dialogs.convert.owner')"
        clearable
        @update:model-value="$emit('update:ownerUserId', $event)"
      />
      <v-textarea
        :model-value="note"
        :label="$t('ncrm.leads.details.dialogs.convert.note')"
        rows="3"
        maxlength="1000"
        auto-grow
        @update:model-value="$emit('update:note', $event)"
      />
    </div>
  </NcrmRecordEditDialog>
</template>

<script>
import NcrmRecordEditDialog from "@/components/ncrm/shared/NcrmRecordEditDialog.vue";

export default {
  name: "NcrmLeadConvertDialog",
  components: {
    NcrmRecordEditDialog,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    saveLabel: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: [Number, String],
      default: 760,
    },
    dealName: {
      type: String,
      default: "",
    },
    dealPipelineId: {
      type: [String, Number, null],
      default: null,
    },
    dealStageId: {
      type: [String, Number, null],
      default: null,
    },
    leadStageId: {
      type: [String, Number, null],
      default: null,
    },
    ownerUserId: {
      type: [String, Number, null],
      default: null,
    },
    note: {
      type: String,
      default: "",
    },
    pipelineOptions: {
      type: Array,
      default: () => [],
    },
    dealStageOptions: {
      type: Array,
      default: () => [],
    },
    leadStageOptions: {
      type: Array,
      default: () => [],
    },
    ownerOptions: {
      type: Array,
      default: () => [],
    },
    selectMenuProps: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    "update:modelValue",
    "update:dealName",
    "update:dealPipelineId",
    "update:dealStageId",
    "update:leadStageId",
    "update:ownerUserId",
    "update:note",
    "pipeline-change",
    "save",
  ],
  methods: {
    emitModelValue(value) {
      this.$emit("update:modelValue", Boolean(value));
    },
    handlePipelineChange(value) {
      this.$emit("update:dealPipelineId", value);
      this.$emit("pipeline-change", value);
    },
  },
};
</script>
